<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">{{msg}}</span>
                </div>
              </b-col>
            </b-row>
          </div>

          <div class="div-section-body">
            <div class="div-padding" v-html="nl2br(blurb)"></div>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils";

var data = {
  debug: false,
  error: false,
  loading: true,
  msg: "Privacy",
  code: "privacy",
  blurb: "",
  studentHash: '',
};

export default {
  name: "Privacy",
  data() {
    return data;
  },
  props: {},
  computed: {},
    methods: {
    goBack() {
      this.$router.go(-1);
    },
    nl2br(msg) {
        return utils.nl2br(msg)
    }
  },
  created() {
    this.studentHash = this.$root.getToken() || '';
    if (this.code) {
      service
        .getBlurb(this.code)
        .then(
          (res => {
            console.log(`back from getBlurb!`);
            if (this.debug) console.log(res);
            if (res.status && res.rowCount !== 0) {
              this.blurb = res.data[0].blurb
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false;
          console.log(`finally...`);
        })
        .catch(e => {
          this.error = true;
          console.log(e);
        });
    }
    else {
        // flag error!
    }
    // this.error = this.$root.getClassId() === 0;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue